.bar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.75rem;
  max-width: 42rem;
}

.hint {
  margin: 0;
  color: var(--text-muted);
}

.error {
  flex-basis: 100%;
  margin: 0;
  color: var(--danger-text);
}
